<template>
  <div>
    <!-- 头部模板 -->
    <header-yjj-m></header-yjj-m>
    <div class="slide-img" ref="slide">
      <img id="slideImg" src="../../../assets/slide-1.jpg" ref="slideImg">
    </div>


    <div class="container">
      <div style="text-align: left">
        <h3 style="margin-top: 20px;">联系我们</h3>
        <div style="margin-top: 10px;line-height: 35px;">
<!--          <p>电  话：<a href="tel:024-48889088"></a>024-48889088</p>-->
          <p>地  址：辽宁省本溪市桓仁满族自治县东关村10组</p>
          <p>邮  编：117200</p>
          <p>网  址：www.hsjyfwzx.com/#/yjj</p>
<!--          <p>邮  箱：Dnkryyj20180903@163.com</p>-->
        </div>
      </div>
      <baidu-map class='bm-view'
                 @ready="initMap"
                 :center="center"
                 :zoom="zoom"
                 :scroll-wheel-zoom="true"
                 style="border: 1px solid silver"
      ></baidu-map>



    </div>


    <!-- 底部模板 -->
    <footer-yjj-m></footer-yjj-m>
  </div>
</template>

<script>
import HeaderYjjM from "@/components/yjj/mobile/HeaderYjjM";
import FooterYjjM from "@/components/yjj/mobile/FooterYjjM";

export default {
  name: "MapYjjM",
  components: {
    HeaderYjjM,
    FooterYjjM
  },
  data(){
    return{

      center: {      // 经纬度
        lng:125.383592,
        lat:41.281093
      },
      zoom: 100,
      BMap:null,      // 百度地图对象
      map:null,       // 百度地图实例
    }

  },
  methods:{
    initMap ({BMap, map}) {
      this.BMap = BMap ;
      this.map = map;
      var point = new BMap.Point(125.383592, 41.281093)
      // this.$set(this.center , 'lng' ,'需要传递的经纬度');
      // this.$set(this.center , 'lat' ,'需要传递的经纬度'  );
      map.centerAndZoom(point, 15);
      map.setCurrentCity('桓仁');


      var marker = new BMap.Marker(point);
      map.addOverlay(marker);

    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>

.container{
  padding:0 15px;
}
.nav{
  text-align: left;
}
.content{

  margin-top: 20px;
}
.bm-view{
  width:100%;
  height:300px;
  margin-top: 20px;
  margin-bottom: 50px;
}

.slide-img{
  width:100%;
  overflow: hidden;
}
.slide-img img{
  width: 100%;
}
</style>
